import { render } from "./ObjectDashboard.vue?vue&type=template&id=89b4b388&scoped=true"
import script from "./ObjectDashboard.vue?vue&type=script&lang=js"
export * from "./ObjectDashboard.vue?vue&type=script&lang=js"

import "./ObjectDashboard.vue?vue&type=style&index=0&id=89b4b388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b4b388"]])

export default __exports__